import React from 'react';
import { clearAuthData } from '../utils/clearAuth';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error('Error caught by boundary:', error, errorInfo);
    
    // You can also log the error to an error reporting service here
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleClearAuth = () => {
    clearAuthData();
  };

  handleGoToLogin = () => {
    // Clear any stored authentication data
    localStorage.removeItem('user');
    window.location.href = '/masterdata';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="page">
          <div className="container-xl">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body text-center">
                    <div className="mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-danger">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                    </div>
                    <h3 className="card-title">Something went wrong</h3>
                    <p className="text-muted">
                      An unexpected error occurred. Please try one of the options below.
                    </p>
                    <div className="d-flex flex-column gap-2">
                      <button 
                        className="btn btn-primary" 
                        onClick={this.handleReload}
                      >
                        Refresh Page
                      </button>
                      <button 
                        className="btn btn-outline-warning" 
                        onClick={this.handleClearAuth}
                      >
                        Clear Session & Reload
                      </button>
                      <button 
                        className="btn btn-outline-secondary" 
                        onClick={this.handleGoToLogin}
                      >
                        Go to Login
                      </button>
                    </div>
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                      <details className="mt-3 text-start">
                        <summary>Error Details (Development)</summary>
                        <pre className="text-danger small mt-2">
                          {this.state.error && this.state.error.toString()}
                          <br />
                          {this.state.errorInfo.componentStack}
                        </pre>
                      </details>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 